<template>
  <div>
    <div v-if="missonList.length !== 0" class="missions-area">
      <p class="section-title">
        <img src="@/assets/mission.svg" />
        ミッション
      </p>
      <ul class="mission-list">
        <li
          v-for="(mission, index) in missonList"
          :key="index"
          @click="onClick(mission)"
        >
          <p>
            {{
              mission.mission_title
                ? mission.mission_title
                : "名称未設定のミッションです"
            }}
          </p>
          <img class="chev" src="@/assets/chevron.svg" />
        </li>
      </ul>
    </div>
    <div class="modal" v-if="selectedMisson">
      <TitleArea
        text="ミッション"
        @click-close="onClickClose"
        :showReturn="true"
      />
      <div class="modal-content-area">
        <div class="book-wrapper">
          <img class="book" src="@/assets/book.svg" />
          <div class="book-content-area">
            <p class="title">
              {{
                selectedMisson.mission_title
                  ? selectedMisson.mission_title
                  : "名称未設定のミッションです"
              }}
            </p>
            <p v-if="!isCleared">
              <img class="point-img" src="@/assets/point.png" />
              <span class="point">{{ selectedMisson.mission_point }}</span>
            </p>
            <p v-else class="isCleared">達成済</p>
          </div>
        </div>
        <div class="mission-content-area">
          <p class="sub-title">ミッション詳細</p>
          <div class="description">
            {{
              selectedMisson.mission_title
                ? selectedMisson.mission_title
                : "説明文未設定のミッションです"
            }}
          </div>
          <hr />
          <img class="mission-img" :src="displayImage" />
          <hr />
          <p
            class="description long"
            v-text="
              selectedMisson.mission_text
                ? selectedMisson.mission_text
                : '説明文未設定のミッションです'
            "
          />
          <hr />
          <InputPhoto
            :distance="distance"
            :isCleared="!!isCleared"
            @set-img="setImg($event)"
          />
          <FarDistanceCaution :distance="photoMissionDistance" />
          <LoginCaution />
          <GetPointDailog
            v-if="isShowGetPointDialog"
            :getPoint="selectedMisson.mission_point"
            @click-close="() => (isShowGetPointDialog = false)"
          />
          <hr />
          <div v-if="thisSpotMissions.length !== 0">
            <p class="title">過去にアップロードした写真</p>
            <ul class="img-list">
              <li
                v-for="image in thisSpotMissions"
                :key="image.id"
                @click="onClickImg(image.imagePath)"
              >
                <img :src="missionImageUrls[image.imagePath]" />
              </li>
            </ul>
            <div class="background" v-if="selectedImgData">
              <div class="closeButton" @click="onCloseImg">
                <img class="closeButtonInner" src="@/assets/close.svg" />
              </div>
              <div class="dialog" v-show="selectedImgData">
                <img
                  v-show="selectedImgData"
                  :src="selectedImgData.imageUrl"
                />
                <p class="like-button" @click="onClickHeart">
                  <img
                    class="heart"
                    v-show="!isReputated"
                    src="@/assets/heart.svg"
                  />
                  <img
                    class="heart"
                    v-show="isReputated"
                    src="@/assets/heart-red.svg"
                  />
                  <span v-if="selectedImgData.Reputation !== 0">{{
                    selectedImgData.Reputation
                  }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import TitleArea from "@/components/Atoms/TitleArea";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";
import InputPhoto from "@/components/Missions/InputPhoto";
import FarDistanceCaution from "@/components/Missions/FarDistanceCaution";
import LoginCaution from "@/components/Missions/LoginCaution";
import GetPointDailog from "@/components/Missions/GetPointDailog";
import Firebase from "./../../firebase";
import { PHOTO_MISSION_INTERVAL, PHOTO_MISSION_DISTANCE } from "../../const.js";

export default {
  name: "show-mission-area",
  components: {
    ButtonTextLink,
    InputPhoto,
    FarDistanceCaution,
    LoginCaution,
    GetPointDailog,
    TitleArea,
  },
  props: {
    missonList: { type: Array, require: true },
    distance: { type: Number, require: true },
    current: { type: String, default: false, required: true },
  },
  computed: {
    ...mapState([
      "missions",
      "registrationData",
      "selectedSpotData",
      "imageReputationList",
    ]),
    thisSpotMissions() {
      const list = this.missions.filter((mission) => {
        return mission.missionId === this.selectedMisson.mission_id;
      });
      this.loadMissionImages(list);
      return list;
    },
    photoMissionDistance() {
      return PHOTO_MISSION_DISTANCE;
    },
    selectedSpot() {
      if (this.current === "RouteSearch") {
        return this.selectedSpotData.dropspot;
      } else if (this.current === "MyPage") {
        return this.selectedSpotData.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedSpotData.jyutai;
      }
    },
    displayDistance() {
      const n = 1;
      return Math.round(this.distance * Math.pow(10, n)) / Math.pow(10, n);
    },
    displayImage() {
      if (this.isCleared) {
        this.thisSpotMissions.filter((mission) => {
          const formattedTargetDate = this.formatDateToCalc(
            new Date(mission.CreatedAt),
          );
          return (
            this.formattedCurrentDate - formattedTargetDate <
            PHOTO_MISSION_INTERVAL
          );
        })[0].imagePath;
      } else {
        return this.selectedMisson.mission_image_url;
      }
    },
    formattedCurrentDate() {
      const formattedCurrentDate = this.formatDateToCalc(new Date());
      return formattedCurrentDate;
    },
    length() {
      return this.thisSpotMissions.length;
    },
    isCleared() {
      return this.thisSpotMissions.filter((mission) => {
        const formattedTargetDate = this.formatDateToCalc(
          new Date(mission.CreatedAt),
        );
        return (
          this.formattedCurrentDate - formattedTargetDate <
          PHOTO_MISSION_INTERVAL
        );
      }).length;
    },
    isReputated() {
      if (!this.selectedImgData) return false;
      return this.imageReputationList.filter((image) => {
        return image.imagePath === this.selectedImgData.imageUrl;
      }).length;
    },
  },
  data() {
    return {
      selectedMisson: undefined,
      selectedImgData: undefined,
      isShowGetPointDialog: false,
      missionImageUrls: {},
    };
  },
  methods: {
    formatDateToCalc(dt) {
      var y = String(dt.getFullYear());
      var m = String(("00" + (dt.getMonth() + 1)).slice(-2));
      var d = String(("00" + dt.getDate()).slice(-2));

      return Number(`${y}${m}${d}`);
    },
    ...mapMutations(["loadingStartMini", "loadingEndMini"]),
    async loadMissionImages(list) {
      var pathUrls = {};
      for (var i in list) {
        const imagePath = list[i].imagePath;
        const url = await Firebase.getImageUrl(imagePath);
        pathUrls[imagePath] = url;
      }
      this.missionImageUrls = {...pathUrls};
    },
    async onClickImg(imagePath) {
      this.loadingStartMini();
      const imageUrl = this.missionImageUrls[imagePath];
      this.selectedImgData = await Firebase.getImage(imageUrl);
      this.selectedImgData = {
        ...this.selectedImgData,
        imageUrl: imageUrl
      }
      this.loadingEndMini();
    },
    onCloseImg() {
      this.selectedImgData = undefined;
    },
    onClick(mission) {
      this.selectedMisson = mission;
    },
    onClickClose() {
      this.selectedMisson = undefined;
    },
    async setImg(imgfile) {
      this.loadingStartMini();

      const imagePath = await Firebase.addImage({
        file: imgfile,
        spot_id: this.selectedMisson.spot,
        mission_id: this.selectedMisson.mission_id,
      });

      await Firebase.clearPhotoMisson({
        image_path: imagePath,
        mission_id: this.selectedMisson.mission_id,
        mission_title: this.selectedMisson.mission_title,
        mission_point: this.selectedMisson.mission_point,
        service_place_id: this.selectedSpot.service_place_id,
        spot_id: this.selectedMisson.spot,
        lat: this.targetLat,
        lon: this.targetLng,
      });
      this.loadingEndMini();
      this.isShowGetPointDialog = true;
    },
    async onClickHeart() {
      this.loadingStartMini();
      if (this.isReputated) {
        const reputation = await Firebase.deleteImageReputation(
          this.selectedSpot,
          this.selectedMisson,
          this.selectedImgData.imageUrl,
        );
        this.selectedImgData = {
          ...this.selectedImgData,
          Reputation: reputation,
        };
      } else {
        const reputation = await Firebase.updateImageReputation(
          this.selectedSpot,
          this.selectedMisson,
          this.selectedImgData.imageUrl,
        );
        this.selectedImgData = {
          ...this.selectedImgData,
          Reputation: reputation,
        };
      }
      this.loadingEndMini();
    },
  },
  mounted() {
    // this.selectedMisson = this.missonList[0];
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.missions-area {
  margin: 2rem 0;
  padding: 0 1.25rem;
}

.modal {
  background-color: white;
  z-index: 5;
  transform: translateZ(5px);
  background: white;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  .modal-content-area {
    padding: 2.5rem 0 3rem 0;
    height: calc(100% - 8rem);
    overflow: scroll;
  }
  .book-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 700/400;
    z-index: -1;

    .book {
      width: 95vw;
      position: absolute;
      z-index: -1;
    }
    .book-content-area {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: calc(100% - 5rem);
      p {
        margin: 0.5rem 0;
        display: flex;
      }

      .title {
        font-size: 1.2rem;
      }

      .point-img {
        width: 32px;
      }
      .point {
        font-weight: 500;
        font-size: 1.25rem;
      }
    }
  }

  .mission-img {
    width: 100%;
  }
  .mission-content-area {
    padding: 0 1.25rem 5rem;
  }
  .sub-title {
    margin: 0.5rem 0;
  }
  .description {
    margin: 0.5rem 0;
    &.long {
      white-space: pre-wrap;
    }
  }
  .img-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    list-style: none;
    gap: 1vw;
    padding: 1vw 0;
    li {
      img {
        width: 22vw;
        height: 22vw;
        object-fit: cover;
      }
    }
  }
}

.isCleared {
  color: #ff7c86;
}

.section-title {
  display: flex;
  align-items: center;
  margin: 0.25rem 0;
  img {
    margin-right: 0.5rem;
    height: 1.2rem;
  }
  p {
    line-height: 20px;
  }
}

hr {
  border: none;
  background: #ddd;
  height: 1px;
}

.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -2rem;
}
.closeButton {
  font-size: 2rem;
  margin-bottom: 1rem;
  .closeButtonInner {
    width: 1rem;
  }
}
.dialog {
  background-color: transparent;
  z-index: 1001;
  width: calc(100% - 2rem * 2);
  max-height: 75%;
  overflow: scroll;
  position: relative;
  img {
    width: 100%;
  }
  .like-button {
    position: absolute;
    bottom: 0.5rem;
    left: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.5rem 0;
    .heart {
      width: 20px;
      margin-right: 0.5rem;
    }
    span {
      color: white;
    }
  }
}

.mission-list {
  list-style: none;
  padding-left: 0;
  border-bottom: 1px #e7e7e7 solid;
  li {
    margin: 0;
    display: flex;
    padding: 1rem 0.5rem;
    border-top: 1px #e7e7e7 solid;
    position: relative;
    align-items: center;
    p {
      margin: 0;
      width: calc(100% - 1.2rem);
    }

    .chev {
      transform: rotate(-90deg);
      height: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelectModal/PhotoMissionArea.vue